export default __webpack_public_path__ + "static/media/Group84123.27a3f773.svg";